import React from 'react';
import Icon from '../Icon';
import './style.css';

const Tag = ({
  label,
  icon,
  iconPosition,
  onClick,
  onClickIcon,
  active,
  style,
  styleIcon,
  styleIconContainer,
  styleLabel,
  selectable,
  image,
  ...otherProps
}) => (
  <div
    className={`tag ${onClick && 'tagSelect'} ${
      selectable && active && 'tagActive'
    } ${selectable && active === false && 'tagInactive'}`}
    style={style}
    onClick={() => (onClick ? onClick(label) : null)}
    {...otherProps}
  >
    {icon && iconPosition === 'left' ? (
      <div
        onClick={() => onClickIcon()}
        className="tagIconContainer tagIconContainerLeft"
        style={styleIconContainer}
      >
        <Icon icon={icon} style={styleIcon} />
      </div>
    ) : (
      image && (
        <div>
          <img
            className="tagIconContainer tagIconContainerLeft"
            src={image}
            style={styleIcon}
            alt=""
          />
        </div>
      )
    )}
    <p style={styleLabel}>{label}</p>
    {icon && (!iconPosition || iconPosition === 'right') && (
      <div
        className="tagIconContainer tagIconContainerRight"
        style={styleIconContainer}
        onClick={() => onClickIcon()}
      >
        <Icon icon={icon} style={styleIcon} />
      </div>
    )}
  </div>
);

export default Tag;
